module.exports = __webpack_public_path__ + "static/media/rating-star-full.024110d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/rating-star-full.svg
// module id = 889
// module chunks = 0